import React from 'react';
import { FmLogo, GpLogo } from 'components/Icons/logos';
import { Typography } from 'antd';
import styles from './styles.module.less';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import { Brand } from 'constants/brand';
import { useBrand } from 'modules/shared/brand/hooks/useBrand';

const { Title, Text } = Typography;

const WelcomeText = {
  [Brand.FM]: {
    title: 'Join Fusion Partners',
    subTitle:
      "In a few clicks you'll be partnering with an industry leader in low-cost trading",
  },
  [Brand.GP]: {
    title: 'Join Global Prime Partners',
    subTitle:
      "In just a few clicks, you'll be partnering with Australia's Lowest Cost Broker",
  },
};

const Logo = ({ brand }) => {
  switch (brand) {
    case Brand.FM:
      return <FmLogo textColorOverride="#6A67CF" />;
    case Brand.GP:
      return <GpLogo textColorOverride="#110D3D" />;
    default: {
      return null;
    }
  }
};

Logo.propTypes = {
  brand: PropTypes.oneOf(Object.values(Brand)).isRequired,
};

const WelcomeMessage = ({ className }) => {
  const { brand } = useBrand();
  const { title, subTitle } = WelcomeText[brand] || {};

  return (
    <div className={clsx(className, styles.wrapper)}>
      <div className={styles.logoWrapper}>
        <Logo brand={brand} />
      </div>
      <div className={styles.textings}>
        <Title level={1} className={styles.title}>
          {title}
        </Title>
        <Text className={styles.subTitle}>{subTitle}</Text>
      </div>
    </div>
  );
};

WelcomeMessage.propTypes = {
  className: PropTypes.string,
};

export default WelcomeMessage;
